import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./Navbar.css";

function Navbar() {
  const { user, role, signOut } = useAuth();

  return (
    <header className="navbar">

      {/* =====================================
          LOGO
      ====================================== */}

      <div className="navbar-container">

        <Link to="/" className="navbar-logo">
          <img
            className="navbar-logo-image"
            src="/strides%20logo.png"
            alt="Strides AAR"
          />
        </Link>


        {/* =====================================
            NAVIGATION
        ====================================== */}

        <nav className="navbar-links">

          <NavLink
            to="/"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            AAR Library
          </NavLink>

          {user && (
            <>
              {role === "admin" && (
                <>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Dashboard
                  </NavLink>

                  <NavLink
                    to="/action-tracker"
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    Action Tracker
                  </NavLink>
                </>
              )}

              {(role === "admin" || role === "viewer") && (
                <NavLink
                  to="/manage-aar"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  Manage AAR
                </NavLink>
              )}

              {(role === "admin" || role === "reviewer") && (
                <NavLink
                  to="/reviewer-inbox"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  Review Inbox
                </NavLink>
              )}

              {role === "admin" && (
                <NavLink
                  to="/activity"
                  className={({ isActive }) =>
                    isActive ? "nav-link active" : "nav-link"
                  }
                >
                  Activity
                </NavLink>
              )}
            </>
          )}

        </nav>


        {/* =====================================
            RIGHT SIDE
        ====================================== */}

        <div className="navbar-right">

          {user ? (
            <div className="navbar-account">
              <div className="navbar-avatar" title={user.email || "Signed-in user"}>
                {user.photoURL ? (
                  <img src={user.photoURL} alt="" />
                ) : (
                  (user.displayName || user.email || "U").charAt(0).toUpperCase()
                )}
              </div>
              <button
                type="button"
                className="logout-button"
                onClick={signOut}
                aria-label="Sign out"
                title="Sign out"
              >
                <span aria-hidden="true">↪</span>
              </button>
            </div>
          ) : (
            <Link to="/login" className="navbar-user">
              Sign in
            </Link>
          )}

        </div>

      </div>

    </header>
  );
}

export default Navbar;